import axios from '../utils/axios';

export default function fetchProLeadReport(adminId,params) {
    return (
        axios.get('/admin/'+ adminId+'/pro-lead-report',{
            params:params
        })
    )
}
